module.exports = __webpack_public_path__ + "img/logo-dark.e86b386e.png";